const AppInfoTypes = {
  FETCH_APP_INFO: "FETCH_APP_INFO",
};

export default AppInfoTypes;



// WEBPACK FOOTER //
// ./src/action-types/appInfo.js